import { createGlobalStyle, css } from 'styled-components';
export const HeaderWedge = createGlobalStyle `
    :root {
        --TopWedge_Height: 6rem;

        @media (min-width: 32.5rem) {
            --TopWedge_Height: 7rem;
        }
    }
`;
export const HeaderSharedStyles = css `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    box-sizing: border-box;
    min-height: 3rem;
    padding: 1.25rem 1rem;
    pointer-events: none;

    a,
    button {
        pointer-events: all;
    }

    @media (min-width: 32.5rem) {
        padding: 2rem;
    }
`;
